<template>
    <div class="search-box" flex="cross:center">
        <div class="select cp" flex="cross:center" @click="searchDialog = !searchDialog">
            <div class="text" v-if="type == 0">{{$lang.get().searchAll}}</div>
            <div class="text" v-else-if="type == 1">{{$lang.get().autoParts}}</div>
            <div class="text" v-else-if="type == 2">{{$lang.get().motorcycle}}</div>
            <div class="icon f0" :class="{fz: searchDialog}">
                <img src="@/assets/image2/down.png" />
            </div>
            <div class="search-pop" @click.stop="" v-if="searchDialog">
                <div class="search-item" @click="changeType(0)">{{$lang.get().searchAll}}</div>
                <div class="search-item" @click="changeType(1)">{{$lang.get().autoParts}}</div>
                <div class="search-item" @click="changeType(2)">{{$lang.get().motorcycle}}</div>
            </div>
        </div>
        <div class="line"></div>
        <input class="flex-1" v-model="keyword" :placeholder="$lang.get().inputPlaceholder"/>
        <div class="search-btn cp" flex="cross:center main:center" @click="toSearch">{{$lang.get().searchBtn}}</div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            keyword: '',
            type: 0,
            searchDialog: false,
        }
    },
    methods: {
        toSearch(){
            window.location.href = `/search?keyword=${this.keyword}&type=${this.type}`
        },
        changeType(type){
            this.type = type
            this.searchDialog = false
        }
    }
}
</script>


<style lang="scss" scoped>

    .search-box{
        width: 1000px;
        height: 65px;
        background: #FFFFFF;
        box-shadow: 0px 5px 20px 1px rgba(0,0,0,0.08);
        border-radius: 33px 33px 33px 33px;
        position: relative;
        z-index: 2;
        margin: 0 auto;
        .select{
            margin-left: 38px;
            position: relative;
            .text{
                font-family: Arial, Arial;
                font-weight: 400;
                font-size: 14px;
                color: #000000;
            }
            .icon{
                img{
                    width: 20px;
                    height: 20px;
                }
                &.fz{
                    img{
                        transform: rotate(180deg);
                    }
                }
            }
            .search-pop{
                position: absolute;
                left: -30px;
                top: 50px;
                border-radius: 10px;
                width: 100px;
                text-align: center;
                background: #fff;
                padding: 10px 0;
                box-shadow: 0px 5px 20px 1px rgba(0,0,0,0.08);
                .search-item{
                    height: 40px;
                    line-height: 40px;
                    cursor: pointer;
                }
            }
        }
        .line{
            width: 1px;
            height: 49px;
            background: #E4E4E4;
            margin: 0 27px;
        }
        input{
            height: 50px;
            border: none;
            outline: none;
            padding: 0;
            margin: 0;
            background: none;
            font-weight: 400;
            font-size: 14px;
            line-height: 0px;
        }
        .search-btn{
            width: 140px;
            height: 55px;
            background: #006346;
            border-radius: 28px 28px 28px 28px;
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            margin-right: 5px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SearchBox.vue